import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthAnonGuard implements CanActivate {
    allowedBypassUrl = ['/subscription'];
    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        if (!this.authService.isAuthenticated()) {
            return true;
        } else {
            if (this.allowedBypassUrl.includes(state.url)) {
                return true;
            } else {
                this.router.navigate(['/app']);
                return false;
            }
        }
    }
}
